import React from 'react'
import NotFound from '../../assets/Images/nf.png'
import './nf.css'

function Notfound() {
  return (
    <div className='not-found'>
        <img src={NotFound} />
    </div>
  )
}

export default Notfound